/* eslint-disable camelcase */
import React, { Component, Fragment } from 'react';
import { Modal, Form, Input, Spin, Alert, Row, Col, Select, Button } from 'antd';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { getVideoInfo, createVideo, editVideo } from '../../../../actions';

const Thumbnail = styled.img`
  border-radius: 5px;
  width: 160px;
  height: 90px;
`;

function getYoutubeId(url) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[7].length === 11) ? match[7] : false;
}

class VideoModal extends Component {
  constructor(props) {
    super(props);
    const { initialValue } = props;
    this.state = {
      values: initialValue ? {
        url: initialValue.url || '',
        title: initialValue.title || [],
        description: initialValue.description || [],
        thumbnail: initialValue.thumbnail || '',
      } : {
        url: '',
        title: [],
        description: [],
        thumbnail: '',
      },
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { info, initialValue } = this.props;
    const { values } = this.state;
    if (nextProps.info !== info) {
      this.setState({
        values: {
          ...values,
          title: nextProps.info ? [{
            lang: 'vi',
            value: nextProps.info.title,
          }] : [],
          description: nextProps.info ? [{
            lang: 'vi',
            value: nextProps.info.description,
          }] : [],
          thumbnail: nextProps.info ? nextProps.info.thumbnailUrl : '',
        },
      });
    }
    if (nextProps.initialValue !== initialValue) {
      this.setState({
        values: nextProps.initialValue ? {
          url: nextProps.initialValue.url || '',
          title: nextProps.initialValue.title || [],
          description: nextProps.initialValue.description || [],
          thumbnail: nextProps.initialValue.thumbnail || '',
        } : {
          url: '',
          title: [],
          description: [],
          thumbnail: '',
        },
      });
    }
  }

  handleUpdateField = (field, value) => {
    const { values } = this.state;
    const { getVideoInfo } = this.props;
    this.setState({
      values: {
        ...values,
        [field]: value,
      },
    });

    if (field === 'url' && value) {
      getVideoInfo(getYoutubeId(value));
    }
  }

  handleSubmit = () => {
    const { values } = this.state;
    const { initialValue, createVideo, editVideo, onCancel } = this.props;
    if (!initialValue) {
      // Create video
      createVideo({ data: values,
        response: {
          success: () => {
            this.setState({
              values: {
                url: '',
                title: [],
                description: [],
                thumbnail: '',
              },
            });
            onCancel();
          },
          failure: () => {},
        } });
    } else {
      // Edit video
      editVideo({ _id: initialValue._id,
        data: values,
        response: {
          success: () => {
            this.setState({
              values: {
                url: '',
                title: [],
                description: [],
                thumbnail: '',
              },
            });
            onCancel();
          },
          failure: () => {},
        } });
    }
  }

  render() {
    const { visible, initialValue, onCancel, infoLoading, infoError, loading } = this.props;
    const { values } = this.state;
    return (
      <Modal
        visible={visible}
        title={initialValue ? 'Cập nhật video' : 'Thêm video'}
        onCancel={onCancel}
        onOk={this.handleSubmit}
        confirmLoading={loading}
        maskClosable={false}
      >
        <Form.Item label="Địa chỉ video">
          <Input
            value={values.url}
            onChange={e => this.handleUpdateField('url', e.target.value)}
            placeholder="https://www.youtube.com/watch?v=qrrJTlmpfso"
          />
        </Form.Item>
        {infoLoading && <Spin style={{ margin: '10px auto' }} />}
        {infoError && <Alert type="error" message="Error" description={JSON.stringify(infoError)} showIcon />}
        {values.title.length > 0 && (
          <Fragment>
            <Form.Item label="Tiêu đề">
              {values.title.map((item, index) => (
                <Row key={index} gutter={16} style={{ width: '100%', marginBottom: 10 }}>
                  <Col sm={8}>
                    <Select
                      style={{ width: '100%' }}
                      placeholder="Ngôn ngữ"
                      value={item.lang}
                      onChange={lang => this.setState({
                        values: {
                          ...values,
                          title: values.title.map((i, idx) => (idx === index ? ({
                            ...i,
                            lang,
                          }) : i)),
                        },
                      })}
                    >
                      <Select.Option value='vi' disabled={values.title.find((i, idx) => i.lang === 'vi' && idx !== index)}>Tiếng Việt</Select.Option>
                      <Select.Option value='en' disabled={values.title.find((i, idx) => i.lang === 'en' && idx !== index)}>Tiếng Anh</Select.Option>
                      {/* <Select.Option value='jp' disabled={values.title.find((i, idx) => i.lang === 'jp' && idx !== index)}>Tiếng Nhật</Select.Option> */}
                    </Select>
                  </Col>
                  <Col sm={values.title.length > 1 ? 15 : 16}>
                    <Input
                      style={{ width: '100%' }}
                      placeholder="Giá trị"
                      value={item.value}
                      onChange={e => this.setState({
                        values: {
                          ...values,
                          title: values.title.map((i, idx) => (idx === index ? ({
                            ...i,
                            value: e.target.value,
                          }) : i)),
                        },
                      })}
                    />
                  </Col>
                  {values.title.length > 1 && <Col sm={1}>
                    <Button
                      shape="circle" icon="close" onClick={() => this.setState({
                        values: {
                          ...values,
                          title: values.title.filter((_, idx) => idx !== index),
                        },
                      })}
                    />
                  </Col>}
                </Row>
              ))}
              {values.title.length < 3 && <Button
                icon="plus" type="dashed" onClick={() => this.setState({
                  values: {
                    ...values,
                    title: [...values.title, { lang: '', value: '' }],
                  },
                })}
              >Thêm ngôn ngữ</Button>}
            </Form.Item>
          </Fragment>
        )}
        {values.description.length > 0 && (
          <Fragment>
            <Form.Item label="Mô tả">
              {values.description.map((item, index) => (
                <Row key={index} gutter={16} style={{ width: '100%', marginBottom: 10 }}>
                  <Col sm={8}>
                    <Select
                      style={{ width: '100%' }}
                      placeholder="Ngôn ngữ"
                      value={item.lang}
                      onChange={lang => this.setState({
                        values: {
                          ...values,
                          description: values.description.map((i, idx) => (idx === index ? ({
                            ...i,
                            lang,
                          }) : i)),
                        },
                      })}
                    >
                      <Select.Option value='vi' disabled={values.title.find((i, idx) => i.lang === 'vi' && idx !== index)}>Tiếng Việt</Select.Option>
                      <Select.Option value='en' disabled={values.title.find((i, idx) => i.lang === 'en' && idx !== index)}>Tiếng Anh</Select.Option>
                      {/* <Select.Option value='jp' disabled={values.title.find((i, idx) => i.lang === 'jp' && idx !== index)}>Tiếng Nhật</Select.Option> */}
                    </Select>
                  </Col>
                  <Col sm={values.description.length > 1 ? 15 : 16}>
                    <Input.TextArea
                      style={{ width: '100%' }}
                      placeholder="Giá trị"
                      value={item.value}
                      onChange={e => this.setState({
                        values: {
                          ...values,
                          description: values.description.map((i, idx) => (idx === index ? ({
                            ...i,
                            value: e.target.value,
                          }) : i)),
                        },
                      })}
                    />
                  </Col>
                  {values.description.length > 1 && <Col sm={1}>
                    <Button
                      shape="circle" icon="close" onClick={() => this.setState({
                        values: {
                          ...values,
                          description: values.description.filter((_, idx) => idx !== index),
                        },
                      })}
                    />
                  </Col>}
                </Row>
              ))}
              {values.description.length < 3 && <Button
                icon="plus" type="dashed" onClick={() => this.setState({
                  values: {
                    ...values,
                    description: [...values.description, { lang: '', value: '' }],
                  },
                })}
              >Thêm ngôn ngữ</Button>}
            </Form.Item>
          </Fragment>
        )}
        {values.thumbnail && (
          <Form.Item label="Ảnh thumbnail">
            <Thumbnail src={values.thumbnail} />
          </Form.Item>
        )}
      </Modal>
    );
  }
}

export default connect(state => ({
  info: state.video.info,
  infoLoading: state.video.infoLoading, 
  infoError: state.video.infoError, 
  loading: state.video.loading, 
}), {
  getVideoInfo,
  createVideo,
  editVideo,
})(VideoModal);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Videos/VideoModal.js